import baseApi from "@/api/baseApi";
export default {
  addOrUpate(form) {
    return baseApi.post('api-article/individual-report/v1', form);
  },
  delete(reportId) {
    return baseApi.delete(`api-article/individual-report/v1/${reportId}`);
  }
}
